import { Injectable, inject } from '@angular/core';
import { LoginService } from './login.service';

@Injectable({ providedIn: 'root' })
export class PermissionService {
    private login = inject(LoginService);
    hasPermission(role: string): boolean { return this.login.session()?.roles?.includes(role) ?? false; }
    hasAction(action: string): boolean { return this.login.session()?.actions?.includes(action) ?? false; }
}
